/**
 * Boolean Input Component for dev-tools
 * Part of Phase 3 refactoring - Component Decomposition (UI Components)
 */
import React from "react";

import { Box, Checkbox, FormControlLabel, FormHelperText } from "@mui/material";

import { FieldSchema } from "../../types";

interface BooleanInputProps {
  field: FieldSchema;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  touched?: boolean;
}

export const BooleanInput: React.FC<BooleanInputProps> = ({
  field,
  value,
  onChange,
  error,
  touched,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
  };

  const showError = Boolean(error && touched);

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={Boolean(value)}
            onChange={handleChange}
            name={field.name}
            color={showError ? "error" : "primary"}
            size="small"
          />
        }
        label={field.name}
        sx={{ mt: 0.5, mb: 0 }}
      />
      {(showError || field.description) && (
        <FormHelperText error={showError} sx={{ ml: 4, mt: 0 }}>
          {showError ? error : field.description}
        </FormHelperText>
      )}
    </Box>
  );
};
